import React, { useEffect, useState } from "react";
import { useAuthenticatedApi } from "@/utils/callApi";
import { BrandButton as Button, Toast } from "@/components";
import HospiceSearchableSelect from "@/components/HospiceSearchableSelect";
import useToast from "@/components/useToast";

export default function ManageHospiceLists() {
  const { secureHelpers } = useAuthenticatedApi();
  const { toast, showToast, hideToast } = useToast();

  const [hospices, setHospices] = useState([]);

  // Create form state
  const [newHospiceId, setNewHospiceId] = useState([]);
  
  // Loading state for hospices
  const [hospicesLoading, setHospicesLoading] = useState(false);
  const [error, setError] = useState(null);
  const [listOfUsers, setListOfUsers] = useState([]);

  useEffect(() => {
    const loadHospices = async () => {
    setHospicesLoading(true);
    try {
      if (import.meta.env.DEV) {
        console.log('Loading hospices from /api/Hospices...');
      }
      const hospicesList = await secureHelpers.get('/api/Hospices');
      if (import.meta.env.DEV) {
        console.log('Hospices loaded:', hospicesList);
      }
      
      if (Array.isArray(hospicesList)) {
        const sortedHospices = hospicesList.sort((a, b) => a.name.localeCompare(b.name));
        setHospices(sortedHospices);
      } else {
        if (import.meta.env.DEV) {
          console.warn('API returned non-array hospices:', hospicesList);
        }
        setHospices([]);
      }
    } catch (err) {
      console.error('Failed to load hospices:', err);
      setError('Unable to load hospices. Please try again or contact support on clinical@hospiceuk.org.');
      setHospices([]);
    } finally {
      setHospicesLoading(false);
    }
  }
    loadHospices();
}, []);

  // handle Users By Hospice
  const handleListUsers = async (id) => {
  if (!id) return;
  try {
    const users = await secureHelpers.get(`/api/Members/ByHospice/${id}`);
    console.log("Users for hospice ID", id, ":", users);
    setListOfUsers(Array.isArray(users) ? users : []);
  } catch (err) {
    console.error("Failed to load users:", err);
  }
};
  
  return (
    <div className="container-fluid py-4">
      <h1 style={{ color: "#F16D09", marginBottom: "2rem" }}>
        Find Users By Hospice
      </h1>

      {/* Toast Notification */}
      <Toast {...toast} onClose={hideToast} />

      {/* First Row */}
      <div className="row g-4 mb-4">
        {/* User By Hospice Card - Halfish Width */}
        <div className="col-md-12">
          <div className="card p-3 h-100">
            <p className="text-muted mb-4">
              Select a hospice from the list below to view associated users.
            </p>

            <Toast {...toast} onClose={hideToast} />

            <div className="row g-4">
              {/* Create new list */}
              <div className="col-md-5">
                <div
                  className="card p-4"
                  style={{ backgroundColor: "#f4f8fa" }}
                >
                  <h2 className="mb-3">Select Hospice</h2>

                  <div className="mb-3">
                             <label className="form-label ">Select Hospice</label>
                             <HospiceSearchableSelect
                               value={newHospiceId}
                               onChange={(value) => { setNewHospiceId(value); console.log("✅ Selected hospice ID:", value); }}
                               placeholder={hospicesLoading ? 'Loading hospices...' : 'Search or select...'}
                               disabled={hospicesLoading}
                               hospices={hospices}
                              multiple={false}
                             />
                             {hospicesLoading && (
                               <small className="text-muted d-flex align-items-center gap-2 mt-1">
                                 <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                 Loading hospices...
                               </small>
                             )}
                           </div>

                  <Button
                    onClick={() => handleListUsers(newHospiceId)}
                  >
                    List Users
                  </Button>
                </div>
              </div>
              <div className="col-md-7">
                <div className="card p-4"
                >
                  <h2 className="mb-3">Users By Selected Hospice</h2>
                  <div>
                  {listOfUsers.length > 0 ? ( <pre style={{ maxHeight: '400px', overflowY: 'auto', backgroundColor: '#f4f8fa', padding: '1rem', borderRadius: '5px' }}>
                    {listOfUsers.map(user => (
                      <>
                      <div key={user.id} style={{ marginBottom: '0.5rem', fontFamily: "'Neutraface-Book', Arial, sans-serif", fontSize: "var(--font-heading-sm)", color: "var(--bs-secondary)" }}>
                       <p>{user.firstName} {user.lastName} : ({user.email})</p>
                      </div>
                      </>
                    ))}

                  </pre> ) : ( <p className="text-muted">No users found for the selected hospice.</p> )}
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  };
